module.exports = __webpack_public_path__ + "img/lasource-21.ee599ff7.jpg";